import { gsap } from '../rk-gsap-core'

const homesHeroAnimation = () => {
  const heroCopy = document.querySelector('.hero-copy')
  const heroCopyShade = heroCopy?.querySelector('.hero-copy-shade')
  const heroCopyElements = heroCopy?.querySelectorAll('h1, h2, p')

  if (!heroCopy || !heroCopyShade || !heroCopyElements) return

  const mm = gsap.matchMedia()

  mm.add('(min-width: 768px)', () => {
    const tl = gsap.timeline({
      defaults: {
        duration: 1,
        ease: 'power2.out'
      }
    })

    tl.to(heroCopyShade, {
      height: '100%',
      duration: 0.7,
      ease: 'power1.out'
    }, 0.25)

    tl.to(heroCopyShade, {
      opacity: 1
    }, 1)

    tl.to(heroCopyElements, {
      opacity: 1,
      stagger: 0.15
    }, 1)
  })  
}

// Homes Page Animations
export default function initializeHomesAnimations() {
  homesHeroAnimation()
}